// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import _ from 'lodash';
import OlSourceVector from 'ol/source/vector';
import OlFeature from 'ol/feature';
import OlLayerVector from 'ol/layer/vector';
import OlStyleStyle from 'ol/style/style';
import OlStyleStroke from 'ol/style/stroke';
import OlStyleCircle from 'ol/style/circle';
import OlStyleFill from 'ol/style/fill';
import OlFormatWKT from 'ol/format/wkt';
import { setChosenFlightById, getFlights, getProducts, getTimeZones } from './../../../../actions/flightManager';
import { finishDrawingFlightGeometry } from './../../../../actions/map';
import { setSelectedTabNameAction } from './../../../../actions/modules';
import { getSelectInteractionManager } from './../../../../utilities/selectInteractionManager';
import { getDrawInteractionManager } from './../../../../utilities/drawInteractionManager';

const FLIGHT_LAYER_NAME = 'Projects';

export class FlightLayer extends React.Component {
    flightSource = null;
    displayedFeatures = [];

    constructor(props) {
        super(props);
        this.flightSource = new OlSourceVector();
        const flightLayer = new OlLayerVector({
            source: this.flightSource,
            zIndex: 0,
            showInLegend: true,
            visible: true,
            name: 'Missions',
            style: new OlStyleStyle({
                stroke: new OlStyleStroke({
                    color: '#2A7BB8',
                    width: 3
                }),
                fill: new OlStyleFill({
                    color: 'rgba(0, 0, 255, 0.0)'
                }),
                image: new OlStyleCircle({
                    radius: 6,
                    fill: new OlStyleFill({
                        color: '#2A7BB8'
                    })
                })
            })
        });
        props.olMap.addLayer(flightLayer);
        this.addFlightFeatureSelectInteraction();
    }

    addFlightFeatureSelectInteraction() {
        const selectConfig = {
            style: new OlStyleStyle({
                stroke: new OlStyleStroke({
                    color: '#2edcd2',
                    width: 4
                }),
                fill: new OlStyleFill({
                    color: 'rgba(0, 0, 255, 0.0)'
                }),
                image: new OlStyleCircle({
                    radius: 6,
                    fill: new OlStyleFill({
                        color: 'rgb(46, 220, 210)'
                    })
                })
            }),
            idColumnName: 'id',
            layerName: FLIGHT_LAYER_NAME,
            onFeatureSelect: this.onFlightFeatureSelect.bind(this),
        }
        getSelectInteractionManager('map').addSelectConfig(selectConfig);
    }

    onFlightFeatureSelect(id) {
        const { setChosenFlightById } = this.props;
        setChosenFlightById(id);
    }

    selectFlightFeature() {
        const { chosenFlight } = this.props;
        if (chosenFlight) {
            const selectedFeature = this.displayedFeatures.find(feature => {
                return feature.get('id') === chosenFlight.id;
            });            
            getSelectInteractionManager('map').selectFeature(FLIGHT_LAYER_NAME, selectedFeature);
        }
        else {
            getSelectInteractionManager('map').selectFeature(FLIGHT_LAYER_NAME, null);   
        }
    }

    updateFlightFeatures() {
        const { flightsData } = this.props;
        this.displayedFeatures = [];
        this.flightSource.clear();
        if (!flightsData) return;

        this.displayedFeatures = flightsData
            .filter(flight => flight.geomWkt)
            .map(flight => {
                const format = new OlFormatWKT();
                const feature = format.readFeature(flight.geomWkt);
                feature.set('id', flight.id);
                feature.set('layerName', FLIGHT_LAYER_NAME);
                this.flightSource.addFeature(feature);
                return feature;
            });
    }

    startDrawingFlight() {
        const { olMap, drawingFlight, finishDrawingFlightGeometry } = this.props;
        if (!drawingFlight) return;

        getDrawInteractionManager('map').startDrawing(olMap, drawingFlight.geometryType, null, (geom) => {            
            let selectedFeature = this.displayedFeatures.find(feature => {
                return feature.get('id') === drawingFlight.id;
            }); 
            if (!selectedFeature) {
                this.flightSource.clear();
                selectedFeature = new OlFeature();
                selectedFeature.set('layerName', FLIGHT_LAYER_NAME);
                this.flightSource.addFeature(selectedFeature);
            }            
            selectedFeature.setGeometry(geom);
            this.flightSource.refresh();

            getSelectInteractionManager('map').selectFeature(FLIGHT_LAYER_NAME, selectedFeature);

            const format = new OlFormatWKT();
            const geomWkt = format.writeGeometry(geom);                        
            drawingFlight.geomWkt = geomWkt;                        
            finishDrawingFlightGeometry();
        });
    }

    finishDrawingFlight(removeFeature) {
        const { olMap } = this.props;
        getDrawInteractionManager('map').finishDrawing(olMap, true);
    }

    componentDidMount() {
        const { axiosInstance, getFlights, getProducts, getTimeZones } = this.props;
        getFlights(axiosInstance);
        getProducts(axiosInstance);
        getTimeZones(axiosInstance);
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.flightsData, this.props.flightsData)) {
            this.updateFlightFeatures();
            this.selectFlightFeature();
        }
        else if (prevProps.chosenFlight !== this.props.chosenFlight) {
            this.selectFlightFeature();
        }

        if (prevProps.drawingFlight === this.props.drawingFlight) return;
        if (this.props.drawingFlight === 'finished') {
            this.finishDrawingFlight(false);
        } else if (this.props.drawingFlight === 'canceled') {
            this.finishDrawingFlight(true);
            this.updateFlightFeatures();
            this.selectFlightFeature();            
        } else if (this.props.drawingFlight) {
            this.startDrawingFlight();
        }
    }

    render() {
        return (null);
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    drawingFlight: state.mapData.get('drawingFlight'),
    flightsData: state.flightManager.get('rawData'),
    chosenFlight: state.flightManager.get('chosenFlight'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    setChosenFlightById,
    finishDrawingFlightGeometry,
    getFlights,
    getProducts,
    getTimeZones,
    setSelectedTabName : setSelectedTabNameAction
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FlightLayer)


// WEBPACK FOOTER //
// ./src/containers/content/map/flights/FlightLayer.jsx